<script>
  import {IframeService} from "@/api/IframeService";

  export default {

    methods: {
      handleBlockSelected: function (block) {
        this.selectedBlocks[block.id] = !this.selectedBlocks[block.id]
        this.selectedBlockIds = this.getSelectedBlocksIds()
      },
      getSelectedBlocksIds: function () {
        const keys = Object.keys(this.selectedBlocks)
        let selectedBlocksIds = keys.filter(key => this.selectedBlocks[key] === true)
        for(let elem of selectedBlocksIds) {
          elem = parseInt(elem)
        }
        return selectedBlocksIds
      },
      onPagination: function() {
        this.selectAllBlocks = false
        this.selectedBlocks = {}
      },
      onLoaded: function() {
        this.selectAllBlocks = false
        this.selectedBlocks = {}
        const blocks = this.getData()
        for (const block of blocks) {
          this.selectedBlocks[block.id] = false
        }
        this.isLoading = false
      },
      onClickLock: function (block = null) {
        if (block) {
          this.selectedBlockForLock = block
        }
        this.showLockConfirmationModal = true
      },
      onClickClone: function (block = null) {
        if (block) {
          this.selectedBlockForCloning = block
        }
        this.showCloningConfirmationModal = true
      },
      onClickDelete: function(block = null) {
        if(block) {
          this.selectedBlockToDelete = block
        }
        this.showDeleteConfirmationModal=true
      },
      onDeleteConfirmCancel: function() {
        this.showDeleteConfirmationModal = false
        this.selectedBlockToDelete = null
      },
      deleteBlock: function() {
        const multiple = this.selectedBlockToDelete === null
        let ids
        if(multiple) {
          ids = this.getSelectedBlocksIds()
        } else {
          ids = parseInt(this.selectedBlockToDelete.id)
        }

        IframeService.deletePage(this.pageResourceIdentifier, ids).then(res => {
          setTimeout(() => {
            if(multiple) {
              this.showToast(this.$t('iframe.blocks_builder.multiple_deleted', {nr: ids.length}), this.$store.state.successToastOptions)
            } else {
              this.showToast(this.$t('iframe.blocks_builder.deleted'), this.$store.state.successToastOptions)
            }
            this.refreshTable()
          }, 500)
        }).catch(err => {
          setTimeout(() => {
            let keys = Object.keys(err.response.data.errors)
            for (let key of keys) {
              let errorMessages = err.response.data.errors[key].map(errors => errors)
              if (errorMessages.some(msg => msg.replaceAll(' ','_').toLowerCase() === 'cannot_delete_block(s)_that_are_assigned_to_flow(s)')) {
                this.showToast(this.$t('iframe.blocks_builder.error_block_used'), this.$store.state.errorToastOptions)
              } else {
                this.showToast(this.$t('iframe.blocks_builder.delete_error'), this.$store.state.errorToastOptions)
              }
            }

          })
        }).finally(() => {
          this.resetAfterAction()
        })
      },
      showCloneModeSelectionModal: function () {
        this.showCloningConfirmationModal = false
        setTimeout(() => {
          this.showCloningModeSelectionModal = true
        }, 250)

      },
      confirmClone: function (selectedCloningMode) {
        const multiple = this.selectedFlowForCloning === null
        console.log(selectedCloningMode.label)
        let ids = multiple ? this.getSelectedProjectsIds() : parseInt(this.selectedFlowForCloning.id)
        if (!selectedCloningMode.label) {
          console.log("No cloning mode choosen")
          this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
          return
        }

        IframeService.cloneBlock(this.pageResourceIdentifier, selectedCloningMode.label.toLowerCase(), ids).then(res => {
          setTimeout(() => {
            if (multiple) {
              this.showToast(this.$t('iframe.flows.multiple_cloned', {nr: ids.length}), this.$store.state.successToastOptions)
            } else {
              this.showToast(this.$t('iframe.flows.cloned'), this.$store.state.successToastOptions)
            }
            this.refresh()
          }, 500)
        }).catch(err => {
          console.log(err)
          this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
        })
          .finally(() => {
            this.resetAfterAction()
          })
      },
      confirmLock: function() {
        const multiple = this.selectedBlockForLock === null
        let ids
        if(multiple) {
          ids = this.getSelectedBlocksIds()
        } else {
          ids = parseInt(this.selectedBlockForLock.id)
        }

        IframeService.lockBlock(this.pageResourceIdentifier, true, ids).then(res => {
          setTimeout(() => {
            if(multiple) {
              this.showToast(this.$t('iframe.blocks_builder.multiple_locked', {nr: ids.length}), this.$store.state.successToastOptions)
            } else {
              this.showToast(this.$t('iframe.blocks_builder.deleted'), this.$store.state.successToastOptions)
            }
            this.refreshTable()
          }, 500)
        }).catch(err => {
          setTimeout(() => {
            let keys = Object.keys(err.response.data.errors)
            for (let key of keys) {
              let errorMessages = err.response.data.errors[key].map(errors => errors)
                this.showToast(this.$t('iframe.blocks_builder.delete_error'), this.$store.state.errorToastOptions)
            }

          })
        }).finally(() => {
          this.resetAfterAction()
        })
      },
      resetAfterAction: function () {
        this.showDeleteConfirmationModal = false
        this.showCloningConfirmationModal = false
        this.showLockConfirmationModal = false
        this.selectAllBlocks = false
        this.selectedBlocks = {}
        const blocks = this.getData()
        for (const block of blocks) {
          this.selectedBlocks[block.id] = false
        }
        this.selectedBlockForCloning = null
        this.selectedCloningMode = null
        this.selectedBlockToDelete = null
        this.selectedBlockForLock = null
        this.selectedBlockIds = this.getSelectedBlocksIds()
        this.selectedProjectsIds = this.getSelectedProjectsIds()
      },
      cancelClone: function () {
        this.showCloningConfirmationModal = false
        this.showCloningModeSelectionModal = false
        this.selectedFlowForCloning = null
      },
      cancelLock: function () {
        this.showLockConfirmationModal = false
        this.selectedBlockForLock = null
      },
      onClickCreateBlock: function() {
        this.showCreateBlock = true
      },
      onCreateBlockCancel: function() {
        this.showCreateBlock = false
      },
      onCreated: function() {
        this.showCreateBlock = false
        this.refreshTable()
      },
      handleBlockClicked: function({event, row}) {
        if(event.srcElement.className ==="selectBlockCheckbox") {
          event.stopPropagation()
        } else {
          this.$router.push(`/${this.iframeService.slug}/${this.iframeService.slug}/blocks-builder/${this.blockTypeIdentifier}/${row.id}`)
        }
      },
    },
    computed: {
      iframeService: function () {
        //return this.$store.state.services.find(service => service.slug === 'iframe') || null
        return this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      },
      cloningConfirmationModalTitle: function () {
        return this.selectedBlockForCloning !== null ? this.$t('iframe.titles.clone_block') : this.$t('iframe.titles.clone_multiple_blocks')
      },
      cloningConfirmationModalBody: function () {
        return this.selectedBlockForCloning !== null
          ? this.$t('iframe.titles.clone_block_modal_body', {name: this.selectedBlockForCloning.name})
          : this.$t('iframe.titles.clone_multiple_block_modal_body', {nr: this.getSelectedBlocksIds().length})
      },
      lockConfirmationModalTitle: function () {
        return this.selectedBlockForCloning !== null ? this.$t('iframe.titles.lock_block') : this.$t('iframe.titles.lock_multiple_blocks')
      },
      lockConfirmationModalBody: function () {
        return this.selectedBlockForLock !== null
          ? this.$t('iframe.titles.lock_block_modal_body', {name: this.selectedBlockForLock.name})
          : this.$t('iframe.titles.lock_multiple_blocks_modal_body', {nr: this.getSelectedBlocksIds().length})
      },
    },
    watch: {
      selectAllBlocks: function(value) {
        const keys = Object.keys(this.selectedBlocks)
        for (const key of keys) {
          this.selectedBlocks[key] = value
        }
        this.selectedBlockIds = this.getSelectedBlocksIds()
      },
    }
  }
</script>
